import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { DEFAULT_COLUMN } from '../constants/marginConstants';

export const MARGIN_MODULE = 'MARGIN';

export const DEFAULT_MARGIN_COLUMNS: Column[] = DEFAULT_COLUMN;

export const setMarginPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: MARGIN_MODULE, default_columns: DEFAULT_MARGIN_COLUMNS, default_order_by: 'name', default_order: 'asc' });
